module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-credit-records"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "component-credit-record"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column expanded"
  }, [_c('h3', {
    staticClass: "mb-0"
  }, [_vm._v("CR" + _vm._s(_vm.item.id)), (_vm.item.service) ? _c('small', [_vm._v(" " + _vm._s(_vm.item.service) + " only")]) : _vm._e()]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('small', [_c('span', [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.type === 'USE') ? _c('span', [_vm._v("  " + _vm._s(_vm.item.walletable_type ? _vm.item.walletable_type : '--') + " " + _vm._s(_vm.item.walletable_id ? _vm.item.walletable_id : '--'))]) : _vm._e()]), _c('div', {
    staticClass: "description",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_vm._v(_vm._s(_vm.item.reason.replace('|', ' - ')))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "fiel-content"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])])]), _c('div', {
    staticClass: "column shrink pl-0"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('CreditRecordButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "row text-center pt-0"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Valid From")]), (_vm.item.valid_from) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_from, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _c('div', {
    staticClass: "field-value"
  }, [_vm._v("--")])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Valid To")]), (_vm.item.valid_to) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_to, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _c('div', {
    staticClass: "field-value"
  }, [_vm._v("--")])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Amount")]), _c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])])])])])]) : _vm._e(), (_vm.$is('usages')) ? _c('div', {
    staticClass: "component-credit-record"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("CR" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('small', [_c('span', [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.type === 'USE') ? _c('span', [_vm._v("  " + _vm._s(_vm.item.walletable_type ? _vm.item.walletable_type : '--') + " " + _vm._s(_vm.item.walletable_id ? _vm.item.walletable_id : '--'))]) : _vm._e()])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Amount")]), _c('h3', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Reason")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.reason))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "fiel-content"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.created_at))])])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11245e21!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/CreditRecord.vue
// module id = 2275
// module chunks = 1